import React from "react";

import Button from "../Field/Button";

import style from "./style.module.css";

export default function Congratulations(props) {
    const {
        nextStep = false
    } = props;
    return (
        <div className={style.congratulations}>
            <div className={style.form}>
                <div className={style.formRow}>
                    <div className={`${style.formRow} ${style.formSubmit}`}>
                        {
                            nextStep === "home" ? (
                                <Button size="buttonFullWidth" label="Explore WW2 Headquarters" link="/home" />
                            ) : (
                                <Button
                                    size="buttonFullWidth"
                                    label="Explore WW2 Headquarters"
                                    onClick={() => window.location.reload()}
                                />
                            )
                        }
                    </div>
                </div>
            </div>
        </div>
    )
}